export const MINIMUM_HIDE_SIDENAV = 1200